import IntroDialog from './IntroDialog';

export default IntroDialog;
